import { InputAdornment } from "@mui/material";
import { ComponentProps, ComponentType } from "react";
import { useFormContext } from "react-hook-form";
import { UseFormRegisterReturn } from "react-hook-form/dist/types/form";

export type IHookedFieldComponent = UseFormRegisterReturn;

export const HookedField = <
  TComponent extends ComponentType<TProps>,
  TProps = ComponentProps<TComponent>
>({
  component: Component,
  ...componentProps
}: {
  component: TComponent;
  helperText?: string;
} & Partial<Omit<TProps, "component">> & {
    name: string;
    currency?: boolean;
  }) => {
  const {
    register,
    getFieldState,
    formState: { errors }, // eslint-disable-line @typescript-eslint/no-unused-vars
  } = useFormContext();
  const { error } = getFieldState(componentProps.name);

  return (
    // @ts-ignore
    <Component
      {...componentProps}
      {...register(componentProps.name)}
      InputProps={{
        ...(componentProps.currency && {
          startAdornment: <InputAdornment position="start">£</InputAdornment>,
        }),
      }}
      error={!!error}
      helperText={error?.message || componentProps?.helperText}
    />
  );
};
